export default __webpack_public_path__ + "static/media/gallery-5-1.d6cb18fc.webp";